import { application } from "./application"
import AnalyticsChartController from "./analytics_chart_controller"
import AutoSubmitController from "./auto_submit_controller"
import DropzoneController from "./dropzone_controller"
import HelloController from "./hello_controller"
import ImportContextController from "./import_context_controller"
import ImportMappingController from "./import_mapping_controller"
import ImportProgressController from "./import_progress_controller"

application.register("analytics-chart", AnalyticsChartController)
application.register("auto-submit", AutoSubmitController)
application.register("dropzone", DropzoneController)
application.register("hello", HelloController)
application.register("import-context", ImportContextController)
application.register("import-mapping", ImportMappingController)
application.register("import-progress", ImportProgressController)
